import { Spinner } from '@cian/ui-kit';
import { clsx } from 'clsx';
import * as React from 'react';

import { Direction } from './direction';
import { DirectionsModalHeader } from './header';

import style from './index.css';
import { IJsonQueryRangeValue } from '../../../../api-models/common/json_query';
import { IDirection } from 'shared/types/geo/direction';

export interface IDirectionsV2Props {
  directions: IDirection[];
  fromMKAD: IJsonQueryRangeValue;
  isLoading: boolean;
  selectedHighwayIds: number[];
  label: string;
  isRedesign?: boolean;
  changeMinFromMKAD(value: number | null): void;
  changeMaxFromMKAD(value: number | null): void;
  deselectHighways(highwaysIds: number[]): void;
  selectHighways(highwaysIds: number[]): void;
}

export class DirectionsV2 extends React.Component<IDirectionsV2Props> {
  public render() {
    const { changeMinFromMKAD, changeMaxFromMKAD, directions, fromMKAD, isLoading, label } = this.props;

    return (
      <>
        <DirectionsModalHeader
          fromMKAD={fromMKAD}
          onChangeMin={changeMinFromMKAD}
          onChangeMax={changeMaxFromMKAD}
          label={label}
        />
        {directions.length > 0 && this.renderColumns()}
        {isLoading && (
          <div className={style['preloader-wrapper']}>
            <Spinner size={50} />
          </div>
        )}
      </>
    );
  }

  private renderColumns = () => {
    return (
      <div className={clsx(style['directions'], this.props.isRedesign && style['directions-redesign'])}>
        {this.getColumns().map((column, index) => (
          <div key={`directions-modal-column-${index}`} className={style['directions-column']}>
            {this.renderColumn(column)}
          </div>
        ))}
      </div>
    );
  };

  private renderColumn(column: IDirection[]) {
    return column.map(({ name, highways }, index) => (
      <Direction
        key={`directions-modal-item-${index}`}
        name={name}
        highways={highways}
        selectHighways={this.props.selectHighways}
        deselectHighways={this.props.deselectHighways}
        selectedHighwayIds={this.props.selectedHighwayIds}
      />
    ));
  }

  private getDirectionsSize = (direction: IDirection[]) => {
    // Высота заголовка относительно детей
    const REL_TITLE_HEIGHT = 2.5;

    // Размер колонки с учётом количества шоссе и названия направления
    return direction.reduce((prev, curr) => {
      return prev + curr.highways.length + REL_TITLE_HEIGHT;
    }, 0);
  };

  private getColumnSize = () => {
    const COLUMNS_COUNT = 4;
    const allDirectionsSize = this.getDirectionsSize(this.props.directions);

    return Math.round(allDirectionsSize / COLUMNS_COUNT);
  };

  /**
   * Возвращает отсортированный по убыванию массив направлений
   */
  private getSortedDirections = () => {
    const directionsClone = Array.from(this.props.directions);

    return directionsClone.sort((a, b) => {
      return b.highways.length - a.highways.length;
    });
  };

  private getColumns() {
    const directions = this.getSortedDirections();
    const columnSize = this.getColumnSize();
    const columns: IDirection[][] = [];

    directions.forEach(direction => {
      const index = columns.findIndex(column => {
        const currentColumnSize = this.getDirectionsSize(column);

        return currentColumnSize + direction.highways.length <= columnSize;
      });

      if (index >= 0) {
        columns[index].push(direction);
      } else {
        columns.push([direction]);
      }
    });

    return columns;
  }
}
